import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CancelIcon from "@mui/icons-material/Cancel";

export const ratingIcons = {
    Excellent: {
        icon: CheckCircleIcon,
        color: "#2ECC71"
    },
    Good: {
        icon: ThumbUpIcon,
        color: "#F1C40F"
    },
    Fair: {
        icon: WarningAmberIcon,
        color: "#E67E22"
    },
    Poor: {
        icon: CancelIcon,
        color: "#E74C3C"
    }
};